import React, { Component, useContext } from 'react'
import { PARTY_COLORS } from '../../constants/colors'
import { isBrowser, isMobile } from 'react-device-detect'
import Img from 'react-image'
import './styles.scss'

import { LocaleContext } from 'contexts/locale'

type Props = {
  data: string[]
  politicianHandler: Function
  closeHandler: Function
  council: string
  locale: string[]
}

type State = {
  isLoading: boolean
  locale: string[]
  globalLocale: string[]
}

const initialState = {
  isLoading: false,
  locale: [],
  globalLocale: []
}

export class OverlayComponent extends Component<Props, State> {
  state = initialState

  componentWillMount() {
    const locale = this.context
    const messages = require('./locales/' + locale + '.yml')
    const globalMessages = require('locales/' + locale + '.yml')
    this.setState({
      locale: messages,
      globalLocale: globalMessages
    })
  }

  componentDidMount() {
    console.log('OVERLAY MOUNTED')
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props || isBrowser) {
      // console.log(this.props.currentPolitician)
    }
  }

  getBirthday(date) {
    if (!date) {
      return '?'
    }
    const day = date.split('.')[0]
    const month = date.split('.')[1]
    const year = date.split('.')[2]

    const today = new Date()
    const birthDate = new Date(year + '-' + month + '-' + day)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  render() {
    const { locale } = this.state
    const {
      currentPolitician,
      escapeName,
      politicianHandler,
      closeHandler
    } = this.props

    const birthday = this.getBirthday(currentPolitician.Geburtsdatum)

    const ImagePlaceholder = showLoader => (
      <div className='ui small square circular image'>
        <img
          src={require('./transparent.png')}
          style={{
            opacity: showLoader ? 0.5 : 1,
            width: '100%',
            margin: isBrowser ? 0 : '0 0.5rem 0 0',
            backgroundColor: PARTY_COLORS[currentPolitician.Partei]
          }}
        />
        {showLoader && <div className='ui active inverted loader' />}
      </div>
    )

    return (
      <div
        className={`overlay-container ${isBrowser ? 'desktop' : ''} ${
          this.props.council
        }`}
      >
        <div className='overlay-control'>
          <div className='ui three top attached buttons'>
            <div className='buttonRowOne'>
              <button
                className='ui tiny basic icon button'
                onClick={closeHandler}
                style={{ textAlign: 'center' }}
              >
                <i className='black icon remove' />
              </button>
            </div>

            <div className='buttonRowTwo'>
              <button
                className='ui basic icon button'
                onClick={() => politicianHandler('back')}
              >
                <i className='icon chevron left' />
              </button>

              <button
                className='ui basic icon button'
                onClick={() => politicianHandler('next')}
              >
                <i className='icon chevron right' />
              </button>
            </div>
          </div>
        </div>
        <div className='ui divider' />
        <table
          className={`ui ${
            isBrowser ? 'small' : 'mini very compact'
          } basic very compact unstackable table`}
        >
          <tr className='top aligned'>
            <td style={{ paddingRight: '0.25rem' }}>
              <h4
                className='ui header'
                style={{ paddingRight: '2rem', marginBottom: '0.2rem' }}
              >
                {currentPolitician.Vorname} {currentPolitician.Nachname}
                {currentPolitician['Funktion ' + this.context] && (
                  <span style={{ fontWeight: 400 }}>
                    , {currentPolitician['Funktion ' + this.context]}
                  </span>
                )}
              </h4>
              <span
                style={{
                  display: 'inline-block',
                  paddingTop: '1rem'
                }}
              >
                <span
                  style={{
                    fontWeight: 800,
                    color: PARTY_COLORS[currentPolitician.Partei]
                  }}
                >
                  {
                    this.state.globalLocale.UI.Global.Parties[
                      currentPolitician.Partei
                    ]
                  }
                </span>
                &nbsp;&nbsp;
                {
                  this.state.globalLocale.UI.Global.Cantons[
                    currentPolitician.Kanton
                  ]
                }
              </span>

              <br />

              <span style={{ display: 'inline-block', paddingRight: '1rem' }}>
                {currentPolitician['DabeiSeit ' + this.context]}
              </span>

              <br />

              {currentPolitician['Fraktion ' + this.context] && (
                <span style={{ color: 'rgba(0,0,0,0.4)' }}>
                  {currentPolitician['Fraktion ' + this.context]}
                  <br />
                </span>
              )}

              <span style={{ paddingTop: '.5rem', display: 'inline-block' }}>
                {currentPolitician['Beruf ' + this.context] && (
                  <>
                    <span style={{ display: 'inline-block' }}>
                      {currentPolitician['Beruf ' + this.context]}
                    </span>
                    <br />
                  </>
                )}

                {currentPolitician.Geburtsdatum && (
                  <>
                    <span>
                      {birthday}{' '}
                      {this.state.globalLocale.UI.Global.General.years}
                    </span>

                    {currentPolitician['Wohnort ' + this.context] && (
                      <span>
                        {currentPolitician['Wohnort ' + this.context] !== ''
                          ? ','
                          : ''}{' '}
                        {currentPolitician['Wohnort ' + this.context]}
                      </span>
                    )}
                  </>
                )}
              </span>
            </td>
            <td rowSpan={5} className='collapsing right aligned'>
              <Img
                src={`https://interaktiv.tagesanzeiger.ch/imageUpload/interaktives-parlament/${escapeName(
                  currentPolitician.Nachname
                )}_${escapeName(currentPolitician.Vorname)}.png`}
                className={`ui circular ${isBrowser ? 'small' : 'small'} image`}
                style={{
                  backgroundColor: PARTY_COLORS[currentPolitician.Partei]
                }}
                loader={ImagePlaceholder(true)}
                unloader={ImagePlaceholder(false)}
              />
            </td>
          </tr>
        </table>
        <p style={{ margin: '1rem auto 3rem auto' }}>
          {currentPolitician['Text ' + this.context]}
        </p>
        <div
          onClick={closeHandler}
          className={`ui basic black tiny ${
            isMobile ? '' : 'bottom attached'
          } icon button`}
          style={{
            textAlign: 'center',
            left: 0,
            width: '100%'
          }}
        >
          <p>
            <i className='icon remove' />
            {locale.Buttons.Close}
          </p>
        </div>
      </div>
    )
  }
}

OverlayComponent.contextType = LocaleContext
